<template>
  <div
    data-component="modal-wrapper"
    v-if="isVisible"
    v-background-color="$store.getters['ui/getBackgroundColor']"
    v-tiled-background-image="$store.getters['ui/getBackgroundImage']"
    @click.self="close"
  >
    <component
      :is="getModalComponent"
      :salesData="salesData"
      :success="success"
      :failure="failure"
      :discountCopy="discountCopy"
      :applicationName="applicationName"
      :tableNumber="$store.getters['iOrderCore/getTableNumber']"
      :location="location"
      :alertsCode="alertsCode"
      :guestLoginCallback="guestLoginCallback"
      :hideAlcoholNotice="hideAlcoholNotice"
    ></component>
  </div>
</template>

<script>
import CheckoutModal from "@/components/checkout/CheckoutModal";
import GuestLoginModal from "@/components/checkout/GuestLoginModal";

export default {
  props: [
    "hideAlcoholNotice",
    "headertext",
    "serviceid",
    "salesData",
    "success",
    "failure",
    "discountCopy",
    "applicationName",
    "location",
    "tableNumber",
    "alertsCode",
    "guestLoginCallback",
  ],
  components: {
    CheckoutModal,
    GuestLoginModal,
  },
  computed: {
    getModalComponent() {
      return this.$store.state.iOrderCheckout.activeModal;
    },
    isVisible() {
      return this.$store.state.iOrderCheckout.modalIsVisible;
    },
  },
  methods: {
    close() {
      this.$store.commit("iOrderCheckout/hideModal");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
@import "@/assets/scss/helpers.scss";

[data-component="modal-wrapper"] {
  position: fixed;
  z-index: 99999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  background-color: rgba(0, 0, 0, 0.5);
  @include whenScreenIs(sm) {
    // max-width:328px;
  }
}
</style>
